module.exports = __webpack_public_path__ + "img/juicer-img.9de8877b.png";